import { Outlet } from 'react-router-dom';

import 'leaflet/dist/leaflet.css';

import { AdminContainer } from '@/components/containers';
import { CustomersTable } from '@/components/tables/customers-table.component';
import { cn } from '@/lib/utils';
import { IfPermitted, UserPermissions } from '@/modules/Permissions';

function Customers() {
  return (
    <IfPermitted permissions={[UserPermissions.CUSTOMER_LIST]}>
      <AdminContainer className={cn('flex flex-col')} title="Customers">
        <CustomersTable />
        <Outlet />
      </AdminContainer>
    </IfPermitted>
  );
}

export default Customers;
